import request from '@/utils/request'

/** 查询七日签到信息 */
export function cycleSignGetInfoApi(params) {
  return request.get('/cycleSign/getInfo', { params })
}

/** 七日签到 */
export function cycleSignSignApi(data) {
  return request.post('/cycleSign/sign', data)
}

/** 签到解锁充值（定向充值） */
export function checkInRechargeStartApi(data) {
  return request.post('/transfer/rechargeStart', data)
}
